import {BREMBO_KEY, BREMBO_PASSWORD, BREMBO_URL, getToken} from "./config.js";
import {handleOnActionPLP} from "./gtm-view-custom-item-list.js";

class CustomCollection extends HTMLElement {
  constructor() {
    super();
    this.myVehicle = null;
    this.collectionId = null;
    this.collectionUrl = null;
    this.collectionTitle = null;
    this.allProducts = [];
    this.currentPage = 1; // Manage the current page internally
    this.filters = {
      product_type: new Set(),
      position: new Set(),
      material: new Set(),
      mfr_label: new Set(),
      priceRange: {
        min: 0,
        max: null,
      },
      wear_indicator: null,
      Instock: false,
      uvCoated: false,
    };

    this.appliedFilters = {}; // Manage applied filters internally
    this.sort = null; // Manage sorting internally
    this.itemsPerPage = 16; // Define items per page
    this.handlePopState = this._handlePopState.bind(this);

    //  Events
    this.handleButtonClick = this._handleSubmitVehicle.bind(this);
    this.handleSortChange = this._handleSortChange.bind(this);
    this.handleFacetsFormSubmit = this._applyFiltersForm.bind(this);
    window.addEventListener("popstate", this.handlePopState);
  }

  // This function is called when the component is added to the DOM to set up event listeners
  connectedCallback() {
    // Function to start api call and render the collection
    this._renderCustomCollection();

    // Query Selectors
    const getSubmitButton = document.querySelector(".add-vehicle-button");
    const deleteVehicleButton = document.querySelector(
      "vehicle-drawer .delete-vehicle-button",
    );
    const sortButtons = document.querySelectorAll(
      ".popover-listbox__custom_options",
    );
    const facetsDrawerSubmitBtn = document.querySelector(
      "#apply-custom-facets",
    );

    if (getSubmitButton) {
      getSubmitButton.addEventListener("click", this.handleButtonClick);
    }

    if (deleteVehicleButton && deleteVehicleButton.textContent === "Delete") {
      deleteVehicleButton.addEventListener("click", this.handleButtonClick);
    }

    // Add event listeners to sort buttons
    sortButtons.forEach((button) => {
      button.addEventListener("click", (event) => {
        this.handleSortChange(button.value, button.textContent);
      });
    });
    // Add event listener to facets drawer submit button
    if (facetsDrawerSubmitBtn) {
      facetsDrawerSubmitBtn.addEventListener(
        "click",
        this.handleFacetsFormSubmit,
      );
    }
  }
  // This function is  called when the component is removed from the DOM to clean up event listeners
  disconnectedCallback() {
    window.removeEventListener("popstate", this.handlePopState);
    const getSubmitButton = document.querySelector(".add-vehicle-button");
    const deleteVehicleButton = document.querySelector(
      "vehicle-drawer .delete-vehicle-button",
    );
    const sortButtons = document.querySelectorAll(
      ".popover-listbox__custom_options",
    );
    const facetsDrawerSubmitBtn = document.querySelector(
      "#apply-custom-facets",
    );
    if (getSubmitButton) {
      getSubmitButton.removeEventListener("click", this.handleButtonClick);
    }

    if (deleteVehicleButton) {
      deleteVehicleButton.removeEventListener("click", this.handleButtonClick);
    }

    sortButtons.forEach((button) => {
      button.removeEventListener("click", this.handleSortChange);
    });

    if (facetsDrawerSubmitBtn) {
      facetsDrawerSubmitBtn.removeEventListener(
        "click",
        this.handleFacetsFormSubmit,
      );
    }
  }

  // Render the custom collection based on the vehicle selected
  // This function is called when the component is added to the DOM
  // It fetches the products and initializes the collection
  // It also handles the initial filters and sorting from query parameters
  // Check if the vehicle is selected and render the collection
  // If the vehicle is not selected, render the default collection
  _renderCustomCollection() {
    const customCollection = document.querySelector("custom-collection-page");
    const collectionBannerText = document.querySelector(
      ".selected_vehicle_name",
    );
    const collection_results = document.querySelector(".product_results");
    const data_results = collection_results.getAttribute("data-results");

    this.collectionId = customCollection.getAttribute("data-collection-id");
    this.collectionUrl = customCollection.getAttribute("data-collection-name");
    this.collectionTitle = customCollection.getAttribute(
      "data-collection-title",
    );

    const idBremboCollection = "633478349149";
    const registeredVehicle = localStorage.getItem("vehicleData");
    const defaultCollection = document.querySelector(".shopify__collection");

    if (!registeredVehicle) {
      collection_results.style.display = "block";
      collection_results.innerHTML = `${
        parseInt(data_results) != 1
          ? `${data_results} RESULTS FOR`
          : `${data_results} RESULT FOR`
      }`;
      this._showDefaultCollection(
        customCollection,
        defaultCollection,
        collectionBannerText,
      );
      return;
    }

    if (idBremboCollection === this.collectionId) {
      this._showDefaultCollection(customCollection, defaultCollection);
      this._updateVehicleBanner(registeredVehicle);
      collection_results.style.display = "block";
      collection_results.innerHTML = `${
        parseInt(data_results) != 1
          ? `${data_results} RESULTS FOR`
          : `${data_results} RESULT FOR`
      }`;
      return;
    }

    this._showCustomCollection(
      customCollection,
      defaultCollection,
      collectionBannerText,
      registeredVehicle,
    );
  }

  _showDefaultCollection(
    customCollection,
    defaultCollection,
    collectionBannerText = null,
  ) {
    if (customCollection) {
      customCollection.classList.remove("car_selected");
      const productList = customCollection.querySelector(".product-list");
      if (productList) {
        productList.innerHTML = "";
      }
    }
    if (defaultCollection) {
      defaultCollection.classList.remove("hidden");
      defaultCollection.style.display = "grid";
      reinitializeCustomSwymButtons();
      renderListView();
    }
    if (collectionBannerText) collectionBannerText.style.display = "none";
  }

  _updateVehicleBanner(registeredVehicle) {
    const vehicleData = JSON.parse(registeredVehicle);
    const carSelected = document.querySelector(
      ".add-vehicle-filters .add-vehicle",
    );
    if (carSelected) {
      carSelected.innerHTML = `${vehicleData.vehicleName} 
        <span class="pulse" style="background-color: #008C06; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 4px;"></span>`;
    }
  }

  _showCustomCollection(
    customCollection,
    defaultCollection,
    collectionBannerText,
    registeredVehicle,
  ) {
    if (defaultCollection) defaultCollection.style.display = "none";
    const vehicleData = JSON.parse(registeredVehicle);
    this.myVehicle = vehicleData;

    if (customCollection) customCollection.classList.add("car_selected");
    if (collectionBannerText) {
      collectionBannerText.style.display = "inline";
      collectionBannerText.textContent = `for ${this.myVehicle.vehicleName}`;
    }

    const carSelected = document.querySelector(
      "custom-collection-page .vehicle-selected",
    );
    if (carSelected) {
      carSelected.innerHTML = `${vehicleData.vehicleName} 
        <span class="pulse" style="background-color: #008C06; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 4px;"></span>`;
    }

    this._getInitialFilters();
    this._fetchAndInitializeProducts();
  }

  _getInitialFilters() {
    const urlParams = new URLSearchParams(window.location.search);

    const pageParam = urlParams.get("page");
    const sortByParam = urlParams.get("sort_by");
    if (pageParam) {
      this.currentPage = parseInt(pageParam, 10); // Set current page from query parameter
    }
    if (sortByParam) {
      this.sort = sortByParam; // Set sorting from query parameter
    }

    const positionFilters = urlParams.getAll("filter.p.m.custom.position");
    const productTypeFilters = urlParams.getAll(
      "filter.p.m.custom.product_type",
    );
    const materialFilters = urlParams.getAll("filter.p.m.custom.material");
    const InStockFilter = urlParams.has("filter.v.availability");
    const surfaceProtectionFilter = urlParams.has(
      "filter.p.m.custom.rust_resistant_coating",
    );
    const wearIndicatorFilter = urlParams.has(
      "filter.p.m.custom.pad_wear_sensor_included",
    );
    const minPrice = urlParams.get("filter.v.price.gte");
    const maxPrice = urlParams.get("filter.v.price.lte");
    const clusterFilters = urlParams.getAll("filter.p.m.custom.mfr_label");

    if (clusterFilters && clusterFilters.length > 0) {
      this.appliedFilters.mfr_label = clusterFilters;
    }

    if (positionFilters.length > 0) {
      this.appliedFilters.position = positionFilters;
    }
    if (productTypeFilters.length > 0) {
      this.appliedFilters.product_type = productTypeFilters;
    }
    if (materialFilters.length > 0) {
      this.appliedFilters.material = materialFilters;
    }
    if (InStockFilter) {
      this.appliedFilters.Instock = true;
    }
    if (surfaceProtectionFilter) {
      this.appliedFilters.surfaceProtection = true;
    }
    if (wearIndicatorFilter) {
      this.appliedFilters.wear_indicator = true;
    }
    if (minPrice && maxPrice) {
      this.appliedFilters.priceRange = {
        min: parseInt(minPrice),
        max: parseInt(maxPrice),
      };
    }

    if (Object.keys(this.appliedFilters).length > 0) {
      // <span style='background-color: red; width: 8px; height: 8px; border-radius: 50%; display: inline-block; margin-right: 4px;'></span>

      const activeFilterIcon = document.querySelector(
        "custom-collection-page facet-floating-filter .text-with-icon span ",
      );

      if (activeFilterIcon) {
        activeFilterIcon.style.display = "inline-block";
      }
    }
    this._showActiveFacets();
  }
  _updateFiltersQueryParams(filters) {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search); // Create a copy of search params

    const activeFilterIcon = document.querySelector(
      "custom-collection-page facet-floating-filter .text-with-icon span ",
    );

    const updateActiveFilterIconDisplay = (hasFilters) => {
      activeFilterIcon.style.display = hasFilters ? "inline-block" : "none";
    };
    // Remove all query params except for "page and sort_by"
    for (let param of [...params.keys()]) {
      if (param !== "page" && param !== "sort_by") {
        params.delete(param);
      }
    }

    if (!filters || Object.keys(filters).length === 0) {
      // Clear Query Params if no filters are applied only keep the page number
      window.history.replaceState(
        {},
        "",
        `${url.pathname}?${params.toString()}`,
      );

      updateActiveFilterIconDisplay(false);
      return;
    }

    updateActiveFilterIconDisplay(true);
    // Reset to page 1 when filters change
    this.currentPage = 1;

    params.set("page", "1");

    // Append new filters to search params
    if (filters.position && filters.position.length > 0) {
      filters.position.forEach((position) => {
        params.append("filter.p.m.custom.position", position);
      });
    }

    if (filters.product_type && filters.product_type.length > 0) {
      filters.product_type.forEach((productType) => {
        params.append("filter.p.m.custom.product_type", productType);
      });
    }

    if (filters.material && filters.material.length > 0) {
      filters.material.forEach((material) => {
        params.append("filter.p.m.custom.material", material);
      });
    }

    if (filters.mfr_label && filters.mfr_label.length > 0) {
      filters.mfr_label.forEach((cluster) => {
        params.append("filter.p.m.custom.mfr_label", cluster);
      });
    }

    if (filters.Instock) {
      params.append("filter.v.availability", "1");
    }

    if (filters.surfaceProtection) {
      params.append("filter.p.m.custom.rust_resistant_coating", "1");
    }

    if (filters.wear_indicator) {
      params.append("filter.p.m.custom.pad_wear_sensor_included", "1");
    }

    // Uncomment this block to handle price range filters if needed
    if (filters.priceRange) {
      if (filters.priceRange.min > 0) {
        params.append("filter.v.price.gte", filters.priceRange.min);
      }
      if (
        filters.priceRange.max < this.filters.priceRange.max ||
        filters.priceRange.min > 0
      ) {
        params.append("filter.v.price.lte", filters.priceRange.max);
      }
    }

    // Update the browser's URL with new query params
    window.history.replaceState({}, "", `${url.pathname}?${params.toString()}`);
  }

  _handleSortChange(sortValue, content) {
    if (content) {
      const sortName = document.querySelector(".sort-by-custom-text");
      sortName.textContent = content;
    }

    // Update the sorting state
    this.updateSorting(sortValue);

    // Update the URL with sorting parameters
    this._updateSortInQuery(sortValue);

    // Re-render the products with new sorting
    this._renderProducts();
  }

  _updateSortInQuery(sortBy) {
    const url = new URL(window.location.href);
    url.searchParams.set("sort_by", sortBy);
    window.history.pushState({}, "", url); // Update URL without reloading
  }

  _handlePopState() {
    const urlParams = new URLSearchParams(window.location.search);
    const pageParam = urlParams.get("page");
    const sortByParam = urlParams.get("sort_by");
    if (pageParam) {
      this.currentPage = parseInt(pageParam, 10);
    } else {
      this.currentPage = 1; // Default to page 1 if no parameter
    }
    if (sortByParam) {
      this.sort = sortByParam; // Update sorting state from query parameter
    }
    this._renderProducts(); // Re-render products
  }

  // Fetch products once from the external API
  async _fetchAndInitializeProducts() {
    try {
      const token = await window.getToken();

      if (!token) {
        throw new Error("Failed to get token");
      }

      // Compatibility search API call to fetch products via submodel id and category id
      const response = await fetch(
        `${BREMBO_URL}/api/compatibility-search?sub_vehicle_id=${this.myVehicle.submodel.id}&category_id=${this.collectionId}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch products: ${response.statusText}`);
      }

      const products = await response.json();

      this.allProducts = products.data; // Update allProducts with fetched data
    } catch (error) {
      console.error("Error fetching token or products:", error);
    }

    this._getFilters();

    this._renderProducts(); // Render products after fetching or falling back
  }

  // Render the filtered and paginated products
  _renderProducts() {
    //
    const filteredProducts = this._applyFiltersAndSorting(this.appliedFilters, this.sort)


    const collection__results = document.querySelector(".product_results");
    if (collection__results) {
      collection__results.style.display = "block";
      collection__results.innerHTML = `${
        filteredProducts.length != 1
          ? `${filteredProducts.length} RESULTS FOR`
          : `${filteredProducts.length} RESULT FOR`
      }`;
    }

    if (
      !this.allProducts ||
      this.allProducts.length === 0 ||
      filteredProducts.length === 0
    ) {
      const productContainer = document.querySelector(
        "custom-collection-page .collection__results",
      );
      const paginationContainer = document.querySelector(".pagination_custom");

      if (paginationContainer) {
        paginationContainer.remove();
      }

      // Add max height 200px to the container

      productContainer.style.minHeight = "200px";

      productContainer.innerHTML = `
        <div class="v-stack gap-6 align-center justify-center h-full ">
          <div class="text-center v-stack gap-3 align-center justify-center">
            <p class="h5 text-allumi predictive-search_product">WE'RE SORRY</p>
            <p class="text-allumi-extended empty-title" >We couldn’t find any compatible products for your ${this.myVehicle.vehicleName} </p>
          </div>
        </div>
      `;

      return;
    }

    const paginatedProducts = this._paginateProducts(
      filteredProducts,
      this.currentPage,
    );

    this._renderPaginationControls(filteredProducts.length);

    showProducts(paginatedProducts, this.collectionTitle, this.collectionUrl); // Render on the page
  }

  _getFilters() {
    if (!this.allProducts || this.allProducts.length === 0) {
      return;
    }

    this.allProducts.forEach((product) => {
      const metafieldsData = product.metafields.reduce((acc, metafield) => {
        acc[metafield.node.key] = metafield.node.value;
        return acc;
      }, {});

      const {
        product_type,
        position,
        prepared_for_pad_wear_sensor,
        material,
        mfr_label,
      } = metafieldsData;

      if (mfr_label) {
        this.filters.mfr_label = this.filters.mfr_label || new Set();
        this.filters.mfr_label.add(mfr_label);
      }

      if (product_type) {
        this.filters.product_type.add(product_type);
      }

      if (position) {
        JSON.parse(position).forEach((pos) => this.filters.position.add(pos));
      }

      if (prepared_for_pad_wear_sensor && !this.filters.wear_indicator) {
        this.filters.wear_indicator = true;
      }
      if (material) {
        this.filters.material.add(material); // Add material to the set
      }

      let productPrice = parseFloat(product.variant[0].price);
      productPrice = Math.ceil(productPrice); // Round up to the nearest integer

      if (!this.filters.priceRange.max) {
        this.filters.priceRange.max = productPrice || 10000;
      } else {
        this.filters.priceRange.max = Math.max(
          this.filters.priceRange.max,
          productPrice,
        );
      }
    });

    // Convert sets to arrays
    this.filters.product_type = Array.from(this.filters.product_type);
    this.filters.position = Array.from(this.filters.position);
    this.filters.material = Array.from(this.filters.material);
    this.filters.mfr_label = Array.from(this.filters.mfr_label) || [];

    this._showFilters();
  }

  /*
   * Apply filters from the facets drawer form
   * Get filters from the fetched products and update the filters state
   * Define which filters to show based on the fetched products
   */

  _showFilters() {
    // Query Selectors
    const positionFilters = document.querySelector(
      "facet-drawer-custom #accordion-filter-p-m-custom-position",
    );

    const productTypeFilters = document.querySelector(
      "facet-drawer-custom #accordion-filter-p-m-custom-product_type",
    );
    const materialFilters = document.querySelector(
      "facet-drawer-custom #accordion-filter-p-m-custom-material",
    );

    // Position Filters
    const positionFilterListItems = positionFilters?.querySelectorAll(
      ".checkbox-list .checkbox-container",
    );

    const mfr_labelFilters = document.querySelector(
      "facet-drawer-custom #accordion-filter-p-m-custom-mfr_label",
    );

    if (mfr_labelFilters) {
      const mfr_labelFilterListItems = mfr_labelFilters.querySelectorAll(
        ".checkbox-list .checkbox-container",
      );

      mfr_labelFilterListItems.forEach((item) => {
        const cluster = item.querySelector("input").value;
        if (!this.filters.mfr_label.includes(cluster)) {
          item.remove();
        }
      });
      const remainingClusterFilterListItems = mfr_labelFilters.querySelectorAll(
        ".checkbox-list .checkbox-container",
      );
      if (remainingClusterFilterListItems.length === 0) {
        mfr_labelFilters.remove();
      }
    }

    positionFilterListItems &&
      positionFilterListItems.forEach((item) => {
        const position = item.querySelector("input").value;
        if (!this.filters.position.includes(position)) {
          item.remove();
        }
      });
    const remainingPositionFilterListItems =
      positionFilters &&
      positionFilters.querySelectorAll(".checkbox-list .checkbox-container");
    if (
      remainingPositionFilterListItems &&
      remainingPositionFilterListItems.length === 0
    ) {
      positionFilters.remove();
    }

    // Product Type Filters
    if (productTypeFilters) {
      const productTypeFilterListItems = productTypeFilters.querySelectorAll(
        ".checkbox-list .checkbox-container",
      );

      productTypeFilterListItems.forEach((item) => {
        const productType = item.querySelector("input").value;
        if (!this.filters.product_type.includes(productType)) {
          item.remove();
        }
      });

      const remainingProductTypeFilterListItems =
        productTypeFilters.querySelectorAll(
          ".checkbox-list .checkbox-container",
        );

      if (remainingProductTypeFilterListItems.length === 0) {
        productTypeFilters.remove();
      }
    }

    // Material Filters
    if (materialFilters) {
      const materialFilterListItems = materialFilters.querySelectorAll(
        ".checkbox-list .checkbox-container",
      );

      materialFilterListItems.forEach((item) => {
        const material = item.querySelector("input").value;
        if (!this.filters.material.includes(material)) {
          item.remove();
        }
      });
      const remainingMaterialFilterListItems = materialFilters.querySelectorAll(
        ".checkbox-list .checkbox-container",
      );

      if (remainingMaterialFilterListItems.length === 0) {
        materialFilters.remove();
      }
    }

    // Price Range Filter
    this._updatePriceRangeInputs();
  }

  /* 
    
    * Update the price range inputs based on the fetched products
    * Set the min and max values for the price range inputs
    * Set the default values and placeholders for the price range inputs
     
    */

  _updatePriceRangeInputs() {
    const priceRangeInputs = document.querySelectorAll(
      'input[type="range"], input[type="number"]',
    );
    const maxPrice = this.filters.priceRange.max;
    const minPrice = this.filters.priceRange.min;

    const appliedMinPrice = this.appliedFilters.priceRange?.min || minPrice;

    const appliedMaxPrice = this.appliedFilters.priceRange?.max || maxPrice;

    const minRange = (appliedMinPrice / maxPrice) * 100;
    const maxRange = (appliedMaxPrice / maxPrice) * 100;

    const rangeGroup = document.querySelectorAll(".price-range .range-group");

    priceRangeInputs.forEach((input) => {
      if (input.type === "range" || input.type === "number") {
        input.max = maxPrice;
        if (input.name === "filter.v.price.lte") {
          input.value = appliedMaxPrice;
          input.placeholder = maxPrice;
        }
        if (input.name === "filter.v.price.gte") {
          input.min = minPrice;
          input.value = appliedMinPrice;
          input.placeholder = minPrice;
        }
      }
    });

    rangeGroup.forEach((group) => {
      group.style.setProperty("--range-min", `${minRange}%`);
      group.style.setProperty("--range-max", `${maxRange}%`);
    });
  }

  // Handle filtering and sorting updates internally
  _applyFiltersAndSorting(filters = {}, sort) {
    let filteredProducts = this._filterProducts(filters);

    let sortedProducts = this._sortProducts(filteredProducts, sort);

    return sortedProducts;
  }

  // Filter products internally
  _filterProducts(filters) {

    if (!Object.keys(filters).length > 0 ) {
      return this.allProducts;
    }

    return this.allProducts.filter((product) => {
      const metafieldsData = product.metafields.reduce((acc, metafield) => {
        acc[metafield.node.key] = metafield.node.value;
        return acc;
      }, {});



      const {
        product_type,
        position,
        prepared_for_pad_wear_sensor,
        material,
        rust_resistant_coating,
        mfr_label,
      } = metafieldsData;

      const positionData = JSON.parse(position || "[]");

      if (
        filters.product_type?.length > 0 &&
        !filters.product_type.includes(product_type)
      ) {
        return false;
      }

      if (
        filters.mfr_label?.length > 0 &&
        !filters.mfr_label.includes(mfr_label)
      ) {
        return false;
      }

      if (
        filters.position?.length > 0 &&
        !filters.position.some((pos) => positionData.includes(pos))
      ) {
        return false;
      }

      if (
        filters.material?.length > 0 &&
        !filters.material.includes(material)
      ) {
        return false;
      }

      if (filters.Instock && product.variant[0].inventoryQuantity === 0) {
        return false;
      }

      if (filters.surfaceProtection && !rust_resistant_coating) {
        return false;
      }

      if (filters.wear_indicator && !prepared_for_pad_wear_sensor) {
        return false;
      }

      if (
        filters.priceRange?.min > 0 &&
        product.variant[0].price < filters.priceRange.min
      ) {
        return false;
      }

      if (
        filters.priceRange?.max &&
        product.variant[0].price > filters.priceRange.max
      ) {
        return false;
      }

      return true;
    });
  }

  // Sort products internally
  _sortProducts(products, sortByValue) {

    // Sort product via alpabetic order
    const defaultSortedProducts = products.sort((a, b) => {

          if (a.title.toLowerCase() < b.title.toLowerCase()) {
            return -1;
          }
          if (a.title.toLowerCase() > b.title.toLowerCase()) {
            return 1;
          }
          return 0;
        });
    
        //Set Brake Fluid products in the end
        defaultSortedProducts.sort((a, b) => {
          if (a.title.toLowerCase().includes("brake fluid")) {
            return 1;
    
          }
          if (b.title.toLowerCase().includes("brake fluid")) {
            return -1;
          }
          return 0;
        }); 
    
    if (!sortByValue) {
      return defaultSortedProducts;
    }

    return defaultSortedProducts.sort((a, b) => {
      if (sortByValue && sortByValue.length > 0) {
        const [sortField, sortOrder] = sortByValue.split("-"); // Split the sort_by value

        if (sortField === "price") {
          return sortOrder === "ascending"
            ? a.variant[0].price - b.variant[0].price
            : b.variant[0].price - a.variant[0].price;
        }

        if (sortField === "title") {
          const titleA = a.title.toLowerCase();
          const titleB = b.title.toLowerCase();
          if (sortOrder === "ascending") {
            return titleA.localeCompare(titleB);
          } else {
            return titleB.localeCompare(titleA);
          }
        }

        if (sortField === "created") {
          const dateA = new Date(a.created_at);
          const dateB = new Date(b.created_at);
          return sortOrder === "ascending" ? dateA - dateB : dateB - dateA;
        }
      }
      return 0;
    });
  }

  // Paginate products internally
  _paginateProducts(products, page = 1, perPage = this.itemsPerPage) {
    const totalPages = Math.ceil(products.length / perPage);
    if (page > totalPages) {
      page = totalPages; // Reset to last page if current page exceeds total pages
    }

    const start = (page - 1) * perPage;
    return products.slice(start, start + perPage);
  }

  // Handle page changes internally
  _handlePageChange(newPage, totalProducts) {
    const totalPages = Math.ceil(totalProducts / this.itemsPerPage);
    if (newPage > totalPages) {
      newPage = totalPages; // Set to last page
    } else if (newPage < 1) {
      newPage = 1; // Set to first page 
    }

    this.currentPage = newPage; // Update current page

    window.scrollTo({top: 100, behavior: "smooth"});
    this._updatePageURL(); // Update the URL with the new page
    this._renderProducts(); // Re-render products based on new page
  }

  _updatePageURL() {
    const url = new URL(window.location.href);
    url.searchParams.set("page", this.currentPage);

    window.history.pushState({}, "", url); // Update the browser URL without refreshing the page
  }

  // Render pagination controls dynamically
  _renderPaginationControls(totalProducts) {
    const totalPages = Math.ceil(totalProducts / this.itemsPerPage);
    let paginationContainer = document.querySelector(".pagination_custom");

    if (!paginationContainer) {
      paginationContainer = document.createElement("div");
      paginationContainer.classList.add(
        "collection__pagination",
        "pagination",
        "pagination_custom",
      );
      const productContainer = document.querySelector("custom-collection-page");
      productContainer.appendChild(paginationContainer); // Append after products
    }

    if (this.currentPage > totalPages) {
      this.currentPage = totalPages;
    }

    // Check if the previous button already exists, if not, create it
    let prevButton = paginationContainer.querySelector(".pagination__prev");
    if (!prevButton) {
      prevButton = document.createElement("button");
      prevButton.classList.add("pagination__item", "pagination__prev");
      prevButton.innerHTML = `<span class="animated-arrow animated-arrow--reverse"></span>`;
      paginationContainer.appendChild(prevButton);
    }

    // Update the "previous" button's disabled state
    if (this.currentPage === 1) {
      prevButton.classList.add("pagination__item--disabled"); // Disable the button
      prevButton.disabled = true;
    } else {
      prevButton.classList.remove("pagination__item--disabled"); // Enable the button
      prevButton.disabled = false;
    }

    // Add click event listener to "previous" button
    prevButton.removeEventListener("click", this.prevButtonListener);
    this.prevButtonListener = () => {
      if (this.currentPage > 1) {
        this._handlePageChange(this.currentPage - 1, totalProducts);
      }
    };
    prevButton.addEventListener("click", this.prevButtonListener);

    let currentPageDisplay = paginationContainer.querySelector(
      ".pagination__current",
    );
    if (!currentPageDisplay) {
      currentPageDisplay = document.createElement("span");
      currentPageDisplay.classList.add("pagination__current");
      paginationContainer.appendChild(currentPageDisplay);
    }

    // Check if the next button already exists, if not, create it
    let nextButton = paginationContainer.querySelector(".pagination__next");
    if (!nextButton) {
      nextButton = document.createElement("button");
      nextButton.classList.add("pagination__item", "pagination__next");
      nextButton.innerHTML = `<span class="animated-arrow"></span>`;
      paginationContainer.appendChild(nextButton);
    }

    // Update the "next" button's disabled state
    if (this.currentPage === totalPages) {
      nextButton.classList.add("pagination__item--disabled"); // Disable the button
      nextButton.disabled = true;
    } else {
      nextButton.classList.remove("pagination__item--disabled"); // Enable the button
      nextButton.disabled = false;
    }

    // Add click event listener to "next" button
    nextButton.removeEventListener("click", this.nextButtonListener);
    this.nextButtonListener = () => {
      if (this.currentPage < totalPages) {
        this._handlePageChange(this.currentPage + 1, totalProducts);
      }
    };
    nextButton.addEventListener("click", this.nextButtonListener);

    // Check if current page display already exists, if not, create it

    // Update the current page display
    currentPageDisplay.innerHTML = `${this.currentPage} / ${totalPages}`;
  }

  // Handle when a vehicle is submitted
  _handleSubmitVehicle(e) {
    e.preventDefault();

    const customCollectionElement = document.querySelector(
      "custom-collection-page",
    );
    if (customCollectionElement) {
      this.currentPage = 1; // Reset to page 1 when vehicle changes
      this.filters = {
        product_type: new Set(),
        position: new Set(),
        material: new Set(),
        mfr_label: new Set(),
        priceRange: {
          min: 0,
          max: null,
        },
        wear_indicator: null,
        Instock: false,
        uvCoated: false,
      };
      this._updatePageURL();
      this._renderCustomCollection(); // Re-render the component after vehicle update
    }
  }
  _clearFiltersAndSorting() {
    // Reset filters and sorting
    this.appliedFilters = {};
    this.sort = null;
    this.currentPage = 1;

    // Remove query parameters (except for the `page` param)
    const url = new URL(window.location.href);
    const params = url.searchParams;

    // Remove all query params except for "page"
    for (let param of params.keys()) {
      if (param !== "page") {
        params.delete(param);
      }
    }
    window.history.replaceState({}, "", `${url.pathname}?${params.toString()}`);

    this._renderProducts();
  }

  // Update filters internally
  updateFilters(newFilters) {
    this.filters = newFilters; // Update filters state
    this.currentPage = 1; // Reset to page 1 when filters change
    this._renderProducts(); // Re-render products based on new filters
  }

  // Update sorting internally
  updateSorting(newSort) {
    this.sort = newSort; // Update sorting state
    this.currentPage = 1; // Reset to page 1 when sorting changes
  }

  _applyFiltersForm() {
    const formDrawer = document.querySelector("#facet-custom-form");
    const sortFilter = formDrawer.querySelector(
      '#custom-checkbox-list-sort input[type="radio"]:checked',
    );
    const positionFilters = formDrawer.querySelector(
      "#facet-custom-form #accordion-filter-p-m-custom-position .accordion__content .checkbox-list",
    );
    const productTypeFilters = formDrawer.querySelector(
      "#facet-custom-form #accordion-filter-p-m-custom-product_type .accordion__content .checkbox-list",
    );
    const materialFilters = formDrawer.querySelector(
      "#facet-custom-form #accordion-filter-p-m-custom-material .accordion__content .checkbox-list",
    );
    const inStock = formDrawer.querySelector(
      "#facet-custom-form #availability",
    );
    const priceRange = formDrawer.querySelector(
      "#facet-custom-form .price-range  .input-group",
    );
    const surfaceProtection = formDrawer.querySelector(
      "#facet-custom-form #uv\\ coated",
    );
    const wear_indicator = formDrawer.querySelector(
      "#facet-custom-form #wear\\ indicator",
    );
    const clusterFilter = formDrawer.querySelector(
      "#facet-custom-form #accordion-filter-p-m-custom-mfr_label .accordion__content .checkbox-list",
    );

    if (sortFilter) {
      this.sort = sortFilter.value;

      this._updateSortInQuery(this.sort);
    }

    if (positionFilters) {
      const positionFilterInputs = positionFilters.querySelectorAll(
        'input[type="checkbox"]:checked',
      );

      positionFilterInputs.length > 0
        ? (this.appliedFilters.position = Array.from(positionFilterInputs).map(
            (input) => input.value,
          ))
        : delete this.appliedFilters.position;
    }

    if (clusterFilter) {
      const clusterFilterInputs = clusterFilter.querySelectorAll(
        'input[type="checkbox"]:checked',
      );

      clusterFilterInputs.length > 0
        ? (this.appliedFilters.mfr_label = Array.from(clusterFilterInputs).map(
            (input) => input.value,
          ))
        : delete this.appliedFilters.mfr_label;
    }

    if (productTypeFilters) {
      const productTypeFilterInputs = productTypeFilters.querySelectorAll(
        'input[type="checkbox"]:checked',
      );

      productTypeFilterInputs.length > 0
        ? (this.appliedFilters.product_type = Array.from(
            productTypeFilterInputs,
          ).map((input) => input.value))
        : delete this.appliedFilters.product_type;
    }
    if (materialFilters) {
      const materialFilterInputs = materialFilters.querySelectorAll(
        'input[type="checkbox"]:checked',
      );

      materialFilterInputs.length > 0
        ? (this.appliedFilters.material = Array.from(materialFilterInputs).map(
            (input) => input.value,
          ))
        : delete this.appliedFilters.material;
    }
    if (inStock) {
      const InStockToggleCheckbox = inStock.querySelector(
        'input[type="checkbox"]',
      );
      InStockToggleCheckbox.checked
        ? (this.appliedFilters.Instock = true)
        : delete this.appliedFilters.Instock;
    }
    if (surfaceProtection) {
      const surfaceProtectionToggleCheckbox = surfaceProtection.querySelector(
        'input[type="checkbox"]',
      );
      surfaceProtectionToggleCheckbox.checked
        ? (this.appliedFilters.surfaceProtection = true)
        : delete this.appliedFilters.surfaceProtection;
    }

    if (wear_indicator) {
      const wearIndicatorToggleCheckbox = wear_indicator.querySelector(
        'input[type="checkbox"]',
      );
      wearIndicatorToggleCheckbox.checked
        ? (this.appliedFilters.wear_indicator = true)
        : delete this.appliedFilters.wear_indicator;
    }

    if (priceRange) {
      const minPrice = priceRange.querySelector(
        'input[name="filter.v.price.gte"]',
      );
      const maxPrice = priceRange.querySelector(
        'input[name="filter.v.price.lte"]',
      );

      let hasPriceRange = false;

      if (minPrice && parseInt(minPrice.value) > 0) {
        if (!this.appliedFilters.priceRange) {
          this.appliedFilters.priceRange = {};
        }
        this.appliedFilters.priceRange.min = parseInt(minPrice.value);
        hasPriceRange = true;
      } else if (
        minPrice &&
        parseInt(minPrice.value) === this.filters.priceRange.min &&
        this.appliedFilters.priceRange?.min
      ) {
        if (this.appliedFilters.priceRange) {
          delete this.appliedFilters.priceRange.min;
          hasPriceRange = false;
        }
      }

      if (
        maxPrice &&
        parseInt(maxPrice.value) > 0 &&
        parseInt(maxPrice.value) < this.filters.priceRange.max
      ) {
        if (!this.appliedFilters.priceRange) {
          this.appliedFilters.priceRange = {};
        }
        this.appliedFilters.priceRange.max = parseInt(maxPrice.value);
        hasPriceRange = true;
      } else if (
        maxPrice &&
        parseInt(maxPrice.value) === this.filters.priceRange.max &&
        minPrice.value > 0 &&
        this.filters.priceRange.max
      ) {
        if (this.appliedFilters.priceRange) {
          delete this.appliedFilters.priceRange.max;

          if (!this.appliedFilters.priceRange.min) {
            hasPriceRange = false;
          }
        }
      }

      if (!hasPriceRange) {
        delete this.appliedFilters.priceRange;
      }
    }

    this._showActiveFacets();
    this._updateFiltersQueryParams(this.appliedFilters);

    this._renderProducts();
  }

  _showActiveFacets() {
    const activeFacetsContainer = document.querySelector(
      "custom-collection-page .custom-active-facets",
    );

    if (!this.appliedFilters || Object.keys(this.appliedFilters).length === 0) {
      activeFacetsContainer.innerHTML = "";
      activeFacetsContainer.style.display = "none";
      return;
    }

    activeFacetsContainer.style.display = "flex";

    const mappedKeyNames = {
      position: "Position",
      product_type: "Product Type",
      material: "Material",
      Instock: "In Stock",
      surfaceProtection: "Surface Protection",
      wear_indicator: "Wear Indicator",
      priceRange: "Price",
      mfr_label: "Cluster",
    };

    const activeFacets = Object.entries(this.appliedFilters)
      .map(([key, value]) => {
        if (Array.isArray(value)) {
          return value
            .map((val) => {
              return `
              <div class="removable-facet">
                ${mappedKeyNames[key] ? mappedKeyNames[key] : key}: ${val}
              </div>
            `;
            })
            .join("");
        } else if (typeof value === "boolean") {
          return `
            <div class="removable-facet">
                ${mappedKeyNames[key] ? mappedKeyNames[key] : key}: True
            </div>
          `;
        } else if (typeof value === "object") {
          return `
            <div class="removable-facet">
              ${mappedKeyNames[key] ? mappedKeyNames[key] : key} : $${
            value.min ? value.min : this.filters.priceRange.min
          } - $${value.max ? value.max : this.filters.priceRange.max}
            </div>
          `;
        }
        return "";
      })
      .join("");

    const clearAll = `<a href="/collections/${this.collectionUrl}" is="facet-link" class="facet-clear-all text-subdued">
      <span class="link">Clear all</span>
    </a> `;

    activeFacetsContainer.innerHTML = `${activeFacets} ${clearAll}`;
  }
}

// Render products on the page
function showProducts(products, collectionTitle, collectionUrl) {
  // Get or create the container specifically for products

  if (!products) {
    console.error("No products to render");
    return;
  }
  const productContainer = document.querySelector(
    "custom-collection-page .collection__results",
  );

  // Clear only the product list, not the entire custom-collection
  productContainer.innerHTML = `
    <div class="v-stack gap-6">
      <reveal-items selector=".product-list > *">
        <product-list class="product-list" role="region" aria-live="polite" data-product-group-gtm-custom="product-group-gtm-custom"></product-list>
      </reveal-items>
    </div>
  `;

  const productList = productContainer.querySelector(".product-list");

  // Create the products' HTML
  const productsHTML = products
    .map((product) => {
      const metafieldsData = product.metafields.reduce((acc, metafield) => {
        acc[metafield.node.key] = metafield.node.value;
        return acc;
      }, {});

      const qualifier = product.qualifier?.split(";")

      const Variant = product?.variant[0];

      const variantId = Variant.id.split("/").pop();

      const productPrice = parseFloat(product.variant[0].price).toFixed(2);
      const compareAtPrice = parseFloat(
        product.variant[0].compareAtPrice,
      ).toFixed(2);

      const productNewLabel =
        metafieldsData.product_label_new &&
        metafieldsData.product_label_new === "true"
          ? "NEW IN"
          : "";
      let priceListHtml = "";

      if (productPrice < compareAtPrice) {
        const discountPercentage = (
          ((compareAtPrice - productPrice) / compareAtPrice) *
          100
        ).toFixed(2);

        priceListHtml = `
        <price-list class="price-list text-allumi text-700 collection-page text-300">
          <sale-price class=" text-on-sale text-sm text-400">$${productPrice}</sale-price>
          <compare-at-price class="text-subdued text-sm line-through">$${compareAtPrice}</compare-at-price>
          <span class="text-allumi text-300">-${discountPercentage}%</span>
        </price-list>
      `;
      } else {
        priceListHtml = `
        <price-list class="price-list text-allumi text-700 collection-page text-300">
          <sale-price class="text-subdued">$${productPrice}</sale-price>
        </price-list>
      `;
      }

      const discountValue =
        productPrice < compareAtPrice ? compareAtPrice - productPrice : 0;

      const productRatingHtml = metafieldsData.badge;
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = productRatingHtml;

      const ratingElement = tempDiv.querySelector(".jdgm-prev-badge");
      const averageRating = ratingElement
        ? ratingElement.getAttribute("data-average-rating")
        : "0.0";

      const itemListId = collectionTitle.replace(/\s+/g, "_").toLowerCase();
      const mainCollection = collectionTitle.split(" ")[0];

      return `
    <div class="each-product-gtm">
      <product-card class="product-card product-card--blends product-card__Card bg-custom text-custom" 
        style="--background: 255 255 255; --text-color: 0 0 0;" 
        handle="${product.online_store_url}">
        <input type="hidden" class="gtm-item-list-id" value=${itemListId}>
        <input type="hidden" class="gtm-item-list-name" value="${collectionUrl}">

        <input type="hidden" class="gtm-item_id" value=${product.shopify_id}>
        <input type="hidden" class="gtm-item_name" value="${product.title}">
        <input type="hidden" class="gtm-item_brand" value="Brembostore">
        <input type="hidden" class="gtm-affiliation" value="Brembostore">
        <input type="hidden" class="gtm-currency" value="USD">
        <input type="hidden" class="gtm-price" value=${
          product.variant[0].price
        }>
        <input type="hidden" class="gtm-variant" value=""${product.title}"">
        <input type="hidden" class="gtm-discount" value=${discountValue}>
        <input type="hidden" class="gtm-item_category1" value="${mainCollection}">
        <input type="hidden" class="gtm-item_category2" value="${collectionUrl}">



        <div class="product-card__figure gtm-href-link-product">
           <button aria-label="Add to Wishlist" data-with-epi="true" class="swym_custom swym-button swym-add-to-wishlist-view-product product_${
             product.shopify_id
           }" data-swaction="addToWishlist" data-product-id="${
        product.shopify_id
      }" data-variant-id="${variantId}" data-product-url="https://brembostore.com/products/${
        product.online_store_url
      }">
         </button>     

             <a href="/products/${
               product.online_store_url
             }" class="product-card__image" data-instant> 
              <img class="product-card__image product-card__image--primary object-contain aspect-square" src="${
                product.featured_image
              }" alt="${product.title}">
              </a>

      
         ${
           product.variant[0].inventoryQuantity > 0
             ? `
            <div class="product-card__quick-buy"><form method="post" action="/cart/add" id="product_form_${product.shopify_id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${variantId}">


              <div class="pointer-fine:hidden">
                  <button type="submit" is="custom-button" class="product-card__mobile-quick-buy-button" aria-label="+ Quick add"><div><svg role="presentation" fill="none" stroke-width="2" focusable="false" width="21" height="21" class="icon icon-quick-buy-cart" viewBox="0 0 21 21">
                    <path d="M17.1668 9.97461H10.9168V3.72461H10.0835V9.97461H3.8335V10.8079H10.0835V17.0579H10.9168V10.8079H17.1668V9.97461Z" fill="white"></path>
                    </svg></div><span class="button__loader">
                    <span></span>
                    <span></span>
                    <span></span>
                  </span>
                  </button>
                </div>

                <div class="pointer-coarse:hidden">
                  <button type="submit" aria-controls="" aria-expanded="false" aria-label="+ Quick add" is="custom-button" class="product-card__mobile-quick-buy-button"><div><svg role="presentation" fill="none" stroke-width="2" focusable="false" width="21" height="21" class="icon icon-quick-buy-cart" viewBox="0 0 21 21">
                    <path d="M17.1668 9.97461H10.9168V3.72461H10.0835V9.97461H3.8335V10.8079H10.0835V17.0579H10.9168V10.8079H17.1668V9.97461Z" fill="white"></path>
                    </svg></div><span class="button__loader">
                    <span></span>
                    <span></span>
                    <span></span>
                    </span>
                    </button>
              </div><input type="hidden" name="product-id" value="${product.shopify_id}"><input type="hidden" name="section-id" value="template--23406240956765__main"></form></div>
         `
             : ""
         }
        </div>
        <div class="product-card__info collection-page ">
          <div class="v-stack  gap-0.5 w-full "> 

            <span class="badge-new">${productNewLabel}</span>
            <span class="font-m product-card__title grid-row-span gtm-href-link-product" style="min-height:0">
            <a href="/products/${product.online_store_url}" class="bold" data-instant="">
              ${product.title}
            </a>
            ${qualifier.map((q) =>  {
              return `<span class="tooltip-text  text-400 text-allumi">${q}</span>`
            }).join("")}
          </span>

          </div>
          <div class="product-card__prices collection-page">
            <span class="text-s text-subdued product__sku text-400 text-allumi">#${
                metafieldsData.partnumber
              }</span>
              <div class="price-rate">
                <price-list class="price-list text-allumi text-700 collection-page  text-300">
                  <sale-price class="text-subdued">${priceListHtml}</sale-price>
                </price-list>
                <a href="/products/${
                  product.online_store_url
                }#shopify-product-reviews" class="rating hidden sm:flex card " title="No reviews">
                  <div div class="rating__stars" role="img" aria-label="0.0 out of 5 stars">
                    <svg role="presentation" fill="none" focusable="false" width="12" height="12" class="rating__star icon icon-rating-star" viewBox="0 0 15 15">
                      <path d="M7.5 0L9.58587 5.2731L15 5.72949L10.875 9.44483L12.1353 15L7.5 12.0231L2.86475 15L4.125 9.44483L0 5.72949L5.41414 5.2731L7.5 0Z" fill="currentColor"></path>
                    </svg>
                  </div>
                  <span class=" text-allumi text-400  text-black-allumi review-count">
                    ${averageRating}
                  </span>     
                </a>
              </div>
              <div class="product-info__badge-list">
                <div class="sold-out-custom">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="9" viewBox="0 0 8 9" fill="none">
                      <circle cx="4" cy="4.5" r="4" fill="#${
                        product.variant[0].inventoryQuantity > 0
                          ? "00BA3F"
                          : "E43038"
                      }"></circle>
                    </svg>
                <span class="text-sm text-allumi-bold">${
                  product.variant[0].inventoryQuantity > 0
                    ? "IN STOCK"
                    : "OUT OF STOCK"
                }  </span>
              </div>
            </div>
          </div>
          
        </div>
      </product-card>
      </div>
    `;
    })
    .join("");
  renderListView(true);

  // Inject the products HTML into the product list
  productList.innerHTML = productsHTML;
  //GTM VIEW ITEM EVENT
  handleOnActionPLP();
  //GTM SELECT ITEM EVENT
  selectCustomCollection();
  // Initialize the Wishlist buttons from APP to the custom collection
  reinitializeCustomSwymButtons(true);
}

let retryCount = 0;
const maxRetries = 5;
let retryDelay = 500;

function reinitializeCustomSwymButtons(customView = false) {
  if (window._swat && typeof _swat.initializeActionButtons === "function") {
    console.log("Reinitializing Swym buttons...", _swat);
    // Reinitialize only the custom buttons
    if (customView) {
      _swat.initializeActionButtons("custom-collection-page .product-list");
    } else {
      _swat.initializeActionButtons(".product-list");
    }
    console.log("Swym buttons initialized successfully");
  } else {
    console.error("Swym script not fully loaded. Retrying...");

    if (retryCount < maxRetries) {
      retryCount++;
      // Exponential backoff for retrying
      retryDelay *= 2; // Increase the delay each time

      setTimeout(() => reinitializeCustomSwymButtons(customView), retryDelay);
    } else {
      console.error("Max retries reached. Swym script failed to load.");
      // Optional: Show fallback message to the user
    }
  }
}

const renderListView = (customView = false) => {
  const customCollection = document.querySelector(".custom_collection");
  const gridViewBtn = customView
    ? customCollection.querySelector("#grid-view")
    : document.querySelector("#grid-view");
  const listViewBtn = customView
    ? customCollection.querySelector("#list-view")
    : document.querySelector("#list-view");
  const productList = customView
    ? customCollection.querySelector(".product-list")
    : document.querySelector(".product-list");

  const setView = (view) => {
    if (view === "list") {
      productList.classList.add("list-view");
      listViewBtn.classList.add("active");
      gridViewBtn.classList.remove("active");
    } else {
      productList.classList.remove("list-view");
      gridViewBtn.classList.add("active");
      listViewBtn.classList.remove("active");
    }

    // Save the user's choice to localStorage
    localStorage.setItem("productView", view);
  };

  gridViewBtn.addEventListener("click", function () {
    setView("grid");
  });

  listViewBtn.addEventListener("click", function () {
    setView("list");
  });

  // Apply the saved view on page load
  const savedView = localStorage.getItem("productView") || "grid"; // Default to grid if no value is saved
  setView(savedView);
};

// Define the custom element
export {CustomCollection};

if (!window.customElements.get("custom-collection-page")) {
  window.customElements.define("custom-collection-page", CustomCollection);
}

function selectCustomCollection() {
  const gtmGroups = document.querySelectorAll(
    '[data-product-group-gtm-custom="product-group-gtm-custom"]',
  );

  gtmGroups.forEach((el) => {
    // Initialize the product data object
    let productData = [];

    let products = el.querySelectorAll(".each-product-gtm");
    if (products) {
      products.forEach((product, index) => {
        function handleProductClick(el) {
          el.addEventListener("click", function () {
            let closestProduct = el.closest(".each-product-gtm");

            //get necessary dynamic data
            let itemListId =
              closestProduct.querySelector(".gtm-item-list-id").value;
            let itemListName = closestProduct.querySelector(
              ".gtm-item-list-name",
            ).value;
            let itemAffiliation =
              closestProduct.querySelector(".gtm-affiliation").value;
            let currency = closestProduct.querySelector(".gtm-currency").value;
            let itemId = closestProduct.querySelector(".gtm-item_id").value;
            let itemName = closestProduct.querySelector(".gtm-item_name").value;
            let itemBrand =
              closestProduct.querySelector(".gtm-item_brand").value;

            let itemCategory1 = closestProduct.querySelector(
              ".gtm-item_category1",
            )?.value;
            let itemCategory2 = closestProduct.querySelector(
              ".gtm-item_category2",
            )?.value;

            let itemVariant =
              closestProduct.querySelector(".gtm-variant")?.value;

            //get static data
            let indexProduct = index + 1;
            let quantityProduct = 1;

            function parsePrice(priceStr) {
              return parseFloat(priceStr.replace(/,/g, ""));
            }
            //get price & discount
            let fullPrice = 0;
            let discount = 0;
            let pricePrd = parsePrice(
              closestProduct.querySelector(".gtm-price").value,
            );

            let comparePricePrd = parsePrice(
              closestProduct.querySelector(".gtm-discount").value,
            );

            if (comparePricePrd > pricePrd) {
              fullPrice = pricePrd;
              discount = parseFloat((comparePricePrd - pricePrd).toFixed(2));
            } else if (pricePrd) {
              fullPrice = pricePrd;
            }
            const productDataObject = {
              item_id: itemId,
              item_name: itemName,
              affiliation: itemAffiliation,
              discount: discount,
              index: indexProduct,
              item_brand: itemBrand,
              item_list_id: itemListId,
              item_list_name: itemListName,
              price: fullPrice,
              currency: currency,
              quantity: quantityProduct,
            };

            //if categories exist, add in productData
            if (itemCategory1) productDataObject.item_category = itemCategory1;
            if (itemCategory2) productDataObject.item_category2 = itemCategory2;

            //if variant exist, add in productData
            if (itemVariant && itemVariant !== "Default Title") {
              productDataObject.item_variant = itemVariant;
            }

            //push on productData
            productData.push(productDataObject);

            //clear dataLayer
            window.dataLayer = window.dataLayer || [];

            window.dataLayer.push({
              ecommerce: null,
            });

            window.dataLayer.push({
              event: "ec_select_item",
              ecommerce: {
                item_list_id: itemListId,
                item_list_name: itemListName,
                items: productData, //update the array with items
              },
            });

            productData = [];
          });
        }

        let cardLinkGtm2 = product.querySelectorAll(".gtm-href-link-product a");
        cardLinkGtm2.forEach((el) => {
          if (el) handleProductClick(el);
        });

        let test = product.querySelectorAll(".product-card__info");
        test.forEach((el) => {
          if (el) handleProductClick(el);
        });
      });
    }
  });
}
